<template>
  <div class="merchant-help-tree-container">
    <el-scrollbar class="merchant-help-tree-scrollbar">
      <el-tree :data="helpConfigTreeList" node-key="id" :props="configProps" icon-class="help-expand-icon" @node-click="handleNodeClick">
        <span class="merchant-help-tree-item" :class="{ 'is-active': selectItem && data.id == selectItem.id }" slot-scope="{ node, data }">
          {{ node.label }}
        </span>
      </el-tree>
    </el-scrollbar>
  </div>
</template>
<script>
import tree from '@/libs/utils/tree-tool'
const treeInstance = tree.createInstance({ pid: 'parentId' })

export default {
  name: 'MerchantHelpTree',
  props: {
    modelValue: Object
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  emits: ['update:modelValue'],
  data() {
    return {
      helpConfigTreeList: [],
      configProps: {
        label: 'title'
      }
    }
  },
  computed: {
    selectItem: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  mounted() {
    this.fetchHelpConfigList()
  },
  methods: {
    async fetchHelpConfigList() {
      const result = await this.$store.dispatch('MerchantHelp/allHelpConfigs', {})
      this.helpConfigTreeList = treeInstance.fromList(result)
    },
    handleNodeClick(data) {
      if (!data.children || data.children.length < 1) {
        this.selectItem = data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.merchant-help-tree-container {
  width: 240px;
  height: 100%;
  border-right: 1px solid #ddd;

  /deep/ .help-expand-icon {
    transform: none;
    line-height: 0;
    padding: 14px 14px 14px 0;
    &::before {
      content: url(../../../assets/tree-expand-plus.svg);
    }
    &.expanded::before {
      content: url(../../../assets/tree-expand-minus.svg);
    }

    &.is-leaf::before {
      visibility: hidden;
    }
  }

  /deep/ .el-tree-node__content {
    height: 40px;
  }

  .merchant-help-tree-scrollbar {
    height: 100%;
    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .merchant-help-tree-item {
    color: #444;
    font-size: 14px;
    &.is-active {
      color: var(--color-primary);
    }
  }

  /deep/ .is-leaf + .merchant-help-tree-item:not(.is-active) {
    color: #aaa;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help/components/merchant-help-tree.vue